<template>
  <div class="image-picker">
    <div class="image-picker__image">
      <img :src="imageUrl" @click="pickFile" width="100%" v-if="imageUrl" />
      <button type="button" class="image-picker__delete" :title="$t('delete-img-picker')" v-if="imageUrl" @click.stop="removeFile">{{ $t('delete-img-picker') }}</button>
    </div>
    <p>
      <input class="a-form-file" type="file" :id="uniqueKey" :ref="uniqueKey" accept="image/*" @change="onFilePicked" />
      <label @click="pickFile" for="file">{{ $t('add-img-picker') }}</label>
    </p>
    <p>
      <button class="a-btn-primary a-btn-primary--small" v-if="displaySave" @click.stop="saveFile">{{ $t('save-img-picker') }}</button>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    imageOriginalUrl: {
      type: String,
      required: false,
      default: ''
    },
    displaySave: {
      type: Boolean,
      required: false,
      default: false
    },
    uniqueKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      imageName: '',
      localImageUrl: null
    }
  },
  computed: {
    imageFile: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    imageUrl: function() {
      return this.localImageUrl !== null ? this.localImageUrl : this.imageOriginalUrl
    }
  },
  methods: {
    pickFile() {
      this.$refs[this.uniqueKey].click()
    },
    onFilePicked(e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.localImageUrl = fr.result
          this.imageFile = files[0]
          this.$emit('change', this.imageFile)
        })
      }
    },
    removeFile() {
      this.imageName = ''
      this.imageFile = ''
      this.localImageUrl = ''
      this.$refs[this.uniqueKey].value = ''
      this.$emit('removeFile')
    },
    saveFile() {
      this.$emit('saveFile')
    }
  }
}
</script>
<style lang="scss">
.image-picker {
  &__image {
    position: relative;
    width: 200px;
  }

  &__delete {
    appearance: none;
    background: #e00c05 url(~@/assets/delete.svg) no-repeat center center;
    background-size: 15px 15px;
    border: 0;
    border-radius: 50%;
    color: transparent;
    cursor: pointer;
    font: 0/0 a;
    height: 26px;
    padding: 0;
    position: absolute;
    right: 10px;
    text-shadow: none;
    top: 10px;
    white-space: nowrap;
    width: 26px;
  }
}
</style>